import './LabelChecklist.scss';
import Logger from '@KrashidBuilt/common/utils/logger';
import React, { Component } from 'react';
import QRCode from 'react-qr-code';
import PropTypes from 'prop-types';
import { FGT_REDIRECT_BASE } from '../../constants';

const logger = new Logger(__filename);

class LabelChecklist extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        logger.extra({ _: this });
        const { checklist, part, hashId, qrDisabled } = this.props;
        const { logo, items } = checklist;
        const { job_id: jobId } = part;
        logger.extra({ logo, items, qrDisabled, jobId, part, hashId });

        return (
            <div className={'LabelChecklist'}>
                <div className={'checklist-container'}>
                    {logo && (
                        <div className={'logo'} style={{ '--aspect-ratio': 21 / 9 }}>
                            <img src={logo} alt={'logo'} />
                        </div>
                    )}

                    {/* if the side form does not disable the qr code and the erp supports the users erp */}
                    {!qrDisabled && (
                        <div key='qr-code' className={'item qr'}>
                            <QRCode size={68} value={`${FGT_REDIRECT_BASE}/${hashId}/${part?.id}`} />
                        </div>
                    )}

                    {items && items.map((item) => (
                        <div key={item} className={'item'}>
                            <div className={'box'} />
                            <div className='text-cell'>
                                <div className={'text'}>{item}</div>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        );
    }
}

LabelChecklist.defaultProps = {
    checklist: {}
};

LabelChecklist.propTypes = {
    checklist: PropTypes.shape(),
    part: PropTypes.shape(),
    hashId: PropTypes.string,
    qrDisabled: PropTypes.bool
};


export default LabelChecklist;